import { Modal } from '@els/els-react--modal';
import { memo } from 'react';
import { useDispatch } from 'react-redux';
import CourseSelectionModal from 'components/common/course-selection-modal/CourseSelectionModal';
import { ProgramSolutionsNavMenu } from 'components/common/ps-nav-menu/ProgramSolutionsNavMenu';
import { checkPathMatchV2 } from 'helpers/app.helper';
import { appActions } from 'redux/ducks/app';
import { DP_PATHS } from 'reports/dp/constants/dp.constant';
import { PS_PATHS } from 'reports/ps/constants';
import useBentoBoxModal from './useBentoBoxModal';
export var BentoBoxModal = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? false : _b, courses = _a.courses, onClickOutSide = _a.onClickOutSide, isEAQTopicMappedHesiExamLoading = _a.isEAQTopicMappedHesiExamLoading, isCWLinkHADAndEHRChecking = _a.isCWLinkHADAndEHRChecking, isHesiReadinessApp = _a.isHesiReadinessApp, hadPrograms = _a.hadPrograms, handleCourseSelectionModal = _a.handleCourseSelectionModal, selectedCourse = _a.selectedCourse, showCourseSelectionModal = _a.showCourseSelectionModal, instructorId = _a.instructorId, _c = _a.autoHideBento, autoHideBento = _c === void 0 ? false : _c, isProgramSolutionsEnabled = _a.isProgramSolutionsEnabled;
    var dispatch = useDispatch();
    var _d = useBentoBoxModal({
        courses: courses,
        isHesiReadinessApp: isHesiReadinessApp,
        hadPrograms: hadPrograms,
        handleCourseSelectionModal: handleCourseSelectionModal,
        instructorId: instructorId,
        onClickOutSide: onClickOutSide
    }), isCWDisable = _d.isCWDisable, isEHRDisable = _d.isEHRDisable, isHADDisable = _d.isHADDisable, isDPDisable = _d.isDPDisable, onDPNavigation = _d.onDPNavigation, onEHRNavigation = _d.onEHRNavigation, onHADNavigation = _d.onHADNavigation, onCWNavigation = _d.onCWNavigation, handleRedirectPage = _d.handleRedirectPage, isCWBentoBoxLinkLoading = _d.isCWBentoBoxLinkLoading, courseSectionsByReport = _d.courseSectionsByReport, onCloseCourseSelectionModal = _d.onCloseCourseSelectionModal, isPRDDisable = _d.isPRDDisable, onPRDNavigation = _d.onPRDNavigation, onPSNavigation = _d.onPSNavigation;
    var bentoBoxProps = {
        CW: {
            disabled: isCWDisable,
            onNavigation: onCWNavigation,
            loading: isCWBentoBoxLinkLoading
        },
        HAD: {
            disabled: isHADDisable,
            onNavigation: onHADNavigation,
            loading: isCWLinkHADAndEHRChecking
        },
        EHR: {
            disabled: isEHRDisable,
            onNavigation: onEHRNavigation,
            loading: isEAQTopicMappedHesiExamLoading
        },
        PRD: {
            disabled: isPRDDisable,
            onNavigation: onPRDNavigation,
            loading: false
        },
        PS: {
            disabled: !isProgramSolutionsEnabled,
            onNavigation: onPSNavigation,
            loading: false,
            isSelected: checkPathMatchV2(Object.values(PS_PATHS))
        },
        DP: {
            disabled: isDPDisable,
            onNavigation: onDPNavigation,
            loading: false,
            isSelected: checkPathMatchV2(Object.values(DP_PATHS))
        },
        onClickOutSide: onClickOutSide
    };
    var courseSelectionModalProps = {
        onCloseModal: onCloseCourseSelectionModal,
        courseSections: courseSectionsByReport,
        initialCourseId: selectedCourse,
        handleRedirectPage: handleRedirectPage
    };
    if (autoHideBento && !(isCWBentoBoxLinkLoading && isCWLinkHADAndEHRChecking && isEAQTopicMappedHesiExamLoading)) {
        if (isCWDisable && isHADDisable && isEHRDisable) {
            dispatch(appActions.setBentoBoxShown(false));
            return <div />;
        }
        dispatch(appActions.setBentoBoxShown(true));
    }
    return (<>
      {visible && (<Modal label="Program Solutions Navigation Menu" onClose={function () { return onClickOutSide === null || onClickOutSide === void 0 ? void 0 : onClickOutSide(); }} shouldHideCloseButton shouldCloseOnEscape={!showCourseSelectionModal}>
          <ProgramSolutionsNavMenu {...bentoBoxProps}/>
        </Modal>)}
      {showCourseSelectionModal && <CourseSelectionModal {...courseSelectionModalProps}/>}
    </>);
};
export default memo(BentoBoxModal);
